<template>
  <div class='tablePage'>
    <el-table
      stripe
      v-loading='loading'
      ref='multipleTable'
      :data='tableData'
      tooltip-effect='dark'
      style='width: 100%'
      :header-cell-style='headCellStyle'
      :height='tableHeight'
      @selection-change='handleSelectionChange'
    >
      <el-table-column type='selection' width='50' stripe />
      <el-table-column v-if='isSys' prop='scopeName' :label="$t('public.table_scope')" show-overflow-tooltip />
      <el-table-column prop='name' :label="$t('public.table_code')" show-overflow-tooltip width='200'>
        <template #default='{ row }'>
          <DeviceCode :device='row'>
            <template #icon='{device}'>
              <i v-icon:theme="['displayTypeConvert', device.type]" v-if='!$slots.icon'></i>
            </template>
            <template #name='{device}'>
              <el-popover placement='top-start' width='auto' trigger='hover'>
                <v-popoer :rowData='device' :typeWay='$attrs.sensorWay' />
                <span slot='reference' :class="{'bolder':device.status === ENUM_DEVICE_STATUS.OFFLINE}">
                            {{ device.displayCode }}
                        </span>
              </el-popover>
            </template>
          </DeviceCode>
        </template>
      </el-table-column>

      <el-table-column prop='carrierName' :label="$t('public.table_carrier')" width='250px'>
        <template #default='{ row }'>
          <CardSwipper :key='Math.random()' :list='row.carrierList'>
            <template #title='{item}'>
              {{ item.sceneName }}
            </template>
            <template #default='{item}'>

              <div class='uk-flex'>
                <div style='width: 30px' class='bd-r uk-flex uk-flex-center'>
                  <i class='uk-margin-remove'
                     @click='handleCarrierFn(item)'
                     v-icon="['carrierTypeConvert',item.type]"></i>
                </div>
                <div class='uk-flex-1'>
                  {{ item.carrierName }}
                </div>
              </div>
            </template>

          </CardSwipper>
        </template>
      </el-table-column>
      <!--            <el-table-column prop="displayCode" :label="$t('integration.number')" show-overflow-tooltip />-->
      <el-table-column prop='timeCode' :label="$t('device.time_zone')" show-overflow-tooltip>
        <template #default='{ row }'>
          <span>{{ shiquFn(row.timeCode) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop='updateTime' :label="$t('public.update_time')" show-overflow-tooltip>
        <template #default='{row}'>
          {{ $timetransition(row.updateTime) }}
        </template>
      </el-table-column>
      <el-table-column prop='optare' fixed='right' :label="$t('public.table_operation')" width='120' align='center'>
        <template #default='{ row }'>
          <el-button type='text' size='small' v-for='item in optareBtn' :key='item.id' :title='$t(item.title)'
                     :icon='item.icon' @click='handle(item.method, row)'></el-button>
          <!-- v-has="item.vHas" -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 监测点详情 -->
    <!-- 监测点详情 -->
    <MonitorDialog :visible.sync='dialogVisible' :carrier-info='carrierDetail'></MonitorDialog>
  </div>
</template>

<script>
import proper from '../components/Proper.vue'
import { carrierTypeConvert, configStatusConvert, displayscreenTypeConvert, equiStatusConvert,shiquArrayConvert } from '@/utils/convert'
import { carrierDetail } from '@/api/modules/carrier.js'
import { getIsSys } from '@/utils/permission'
import CardSwipper from '@/components/CardSwipper/CardSwipper.vue'
import MonitorDialog from '@/pages/equipment/publicCom/MonitorDialog.vue'
import DeviceCode from '@/pages/equipment/publicCom/DeviceCode.vue'
import { ENUM_DEVICE_STATUS } from '@/common/enum/forward/device'

export default {
  computed: {
    ENUM_DEVICE_STATUS () {
      return ENUM_DEVICE_STATUS
    }
  },
  props: ['loading', 'tableData', 'shiquArray'],
  components: {
    DeviceCode,
    MonitorDialog,
    CardSwipper,
    'v-popoer': proper
  },
  data () {
    return {
      displayscreenTypeConvert,
      equiStatusConvert,
      configStatusConvert,
      carrierTypeConvert,
      tableHeight: '100%',
      optareBtn: [
        {
          id: 1,
          title: $t('public.stop'),
          icon: 'el-icon-video-pause',
          vHas: [],
          method: 'stopUseFn'
        },
        {
          id: 2,
          title: $t('public.config'),
          icon: 'el-icon-setting',
          vHas: [],
          method: 'configFn'
        },
        {
          id: 3,
          title1: $t('integration.pause_alarm'),
          icon: 'iconfont icon-guanbibaojing',
          vHas: [],
          method: 'stopAlarmFn'
        },
        {
          id: 4,
          title: 'public.details',
          icon: 'el-icon-tickets',
          vHas: [],
          method: 'detailFn'
        }
      ],
      typeArray: [
        {
          type: 1,
          icon: 'iconfont icon-lcd',
          title: $t('deviceType.dt_1')
        }
      ],
      isSys: true,
      carrierDetail: '',
      dialogVisible: false,
      isLoading: false
    }
  },
  mounted () {
    this.isSys = getIsSys()
  },
  methods: {
    handleClose () {
      this.dialogVisible = false
    },
    handleSelectionChange (row) {
      this.$emit('choozeTable', row)
    },
    handle (method, row) {
      this.$emit(method, row)
    },

    shiquFn (type) {
      let str = ''
      for (const item of this.shiquArray) {
        if (type === item.code) {
          str = $t(shiquArrayConvert(item.code))
          break
        }
      }
      return str
    },
    handleCarrierFn (item) {
      carrierDetail(item.type, item.id)
        .then(({ result }) => {
          this.dialogVisible = true
          this.isLoading = true
          this.carrierDetail = result
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang='scss' scoped>
.tablePage {
  height: calc(100% - 60px);
}
</style>
